module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image3-da98fe1c7bd567faf1cd5c0bb958e8da.png";